import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@ibe.components/shared/shared.module';
import { StepsModule } from '../steps/steps.module';
import { BookingOptionsModule } from '../options/options.module';
import { ShoppingCartModule } from '../shopping-cart/shopping-cart.module';
import { PaymentPageComponent } from './payment-page/payment-page.component';
import { INDRAPaymentPageComponent } from './payment-page/payment-page.indra.component';
import { TAPCommonModule } from '@ibe.components/common/common.module';
import { PaymentModule as SelectPaymentModule } from '@ibe.components/shared/payment/payment.module';
import { PaymentExtrasMilesComponent } from './payment-miles/payment-extras-miles/payment-extras-miles.component';
// import { TAPPaymentExtrasMilesComponent } from './payment-miles/payment-extras-miles/payment-extras-miles.tap.component';
import { MilesSliderControlComponent } from './payment-miles/miles-slider-control/miles-slider-control.component';
// import { TAPMilesSliderControlComponent } from './payment-miles/miles-slider-control/miles-slider-control.tap.component';
import { ExtrasFlightModule } from '@ibe.components/booking/extras/extras-flight/extras-flight.module';

import { INDRAMilesSliderControlComponent } from './payment-miles/miles-slider-control/miles-slider-control.indra.component';
import { INDRAPaymentExtrasMilesComponent } from './payment-miles/payment-extras-miles/payment-extras-miles.indra.component';


@NgModule({
	imports: [
		CommonModule,
		TAPCommonModule,
		ExtrasFlightModule,
		SharedModule,
		StepsModule,
		BookingOptionsModule,
		ShoppingCartModule,
		SelectPaymentModule
	],
	declarations: [
		PaymentPageComponent,
		INDRAPaymentPageComponent,
		PaymentExtrasMilesComponent,
		// TAPPaymentExtrasMilesComponent,
		INDRAPaymentExtrasMilesComponent,
		MilesSliderControlComponent,
		// TAPMilesSliderControlComponent
		INDRAMilesSliderControlComponent
	],
	exports: [
		INDRAMilesSliderControlComponent,
		INDRAPaymentExtrasMilesComponent
	]
})
export class PaymentModule { }
